import type { FC } from 'react';

import { ConfirmParticipantOperationModal } from './ConfirmParticipantOperationModal';
import { BUYER_EMAIL_CHANGE_NOTICE_MESSAGE } from './BuyerEmailChangeNotice';

export const SWAP_ERROR_TITLE = 'Swap Failed';
export const SWAP_ERROR_MESSAGE = 'The buyer and co-buyer could not be swapped. Please try again.';

type SwapBuyerCoBuyerModalProps = {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    isSwapping: boolean;
    hasFailed: boolean;
    showBuyerEmailChangeNotice?: boolean;
};

export const SwapBuyerCoBuyerModal: FC<SwapBuyerCoBuyerModalProps> = ({
    show,
    onConfirm,
    onCancel,
    isSwapping,
    hasFailed,
    showBuyerEmailChangeNotice
}) => (
    <ConfirmParticipantOperationModal
        show={show}
        onConfirm={onConfirm}
        onCancel={onCancel}
        isPending={isSwapping}
        hasFailed={hasFailed}
        id="swap-buyer-cobuyer-modal"
        dataTestIdPrefix="swap-buyer-cobuyer"
        header="Swap Co-Buyer"
        prompt="Are you sure you want to swap the buyer and co-buyer?"
        confirmLabel="Swap"
        errorTitle={SWAP_ERROR_TITLE}
        errorMessage={SWAP_ERROR_MESSAGE}
        reminder={showBuyerEmailChangeNotice && BUYER_EMAIL_CHANGE_NOTICE_MESSAGE}
    />
);
